import { render, staticRenderFns } from "./ModelSubscriptions.vue?vue&type=template&id=5b1922ce&scoped=true"
import script from "./ModelSubscriptions.vue?vue&type=script&lang=js"
export * from "./ModelSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./ModelSubscriptions.vue?vue&type=style&index=0&id=5b1922ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1922ce",
  null
  
)

export default component.exports